import "./style.scss";
const PageLoader = () => {
	return (
		<div className="page-loader-wrapper">
			<div className="page-loader"></div>
		</div>
	);
};

export default PageLoader;
